//INCRIPTACION
// import CryptoJS from "crypto-js";
import logo_ext from "@/assets/logo_nuevo.jpeg"
import logo_red from "@/assets/logo_circulo.png"
// import Axios from "axios";
import logo_back from "@/assets/fondo_mantenimiento.png";

import Axios from 'axios'


//INCRIPTACION
import CryptoJS from "crypto-js";

export default {
  data: () => ({
    drawer: false,
    group: null,
    notificaciones: [],
    hasScroll: false,

    items_perfil: [
      { text: 'Mi Perfil', icon: 'portrait', accion: "perfil", path: "/perfil_usuario/-1" },
      { text: 'Reporte Anual y Libro de Compras/Ventas', icon: 'event_note', accion: "cerrar", path: "/reporte_mensual_anual_usuario" },
      { text: 'Estado de declaración', icon: 'view_timeline', accion: "cerrar", path: "/estado_declaracion" },
      { text: 'Términos de Privacidad y Servicios', icon: 'privacy_tip', accion: "cerrar", path: "/terminos_privacidad_servicio" },
      { text: 'Compras', icon: 'shopping_cart', accion: "", path: "/seleccion_facturas_compras" },

      { text: 'Cerrar Sesión', icon: 'logout', accion: "cerrar", path: "/cerrarSesion" }
      // { text: 'Reporte de Acciones', icon: 'summarize', accion: "reporte", path: "/reporte" },
    ],


    items_perfil_empleado_admin: [
      { text: 'Cerrar Sesión', icon: 'logout', accion: "cerrar", path: "/cerrarSesion" }
      // { text: 'Reporte de Acciones', icon: 'summarize', accion: "reporte", path: "/reporte" },
    ],

    items_perfil_empleado_declaracion: [
      { text: 'Listado de Declaraciones listas para formulario', icon: 'payments', accion: "reporte", path: "/pago_declaracion" },
      { text: 'Listado de declaraciones pendientes de confirmación de pago', icon: 'playlist_add_check_circle', accion: "cerrar", path: "/reporte_declaracion" },
      { text: 'Transacciones', icon: 'receipt_long', accion: "transaccion", path: "/transaccion/listado" }

    ],

    items_perfil_empleado_carga: [
      { text: 'Listado de clientes a declarar por dia', icon: 'receipt_long', accion: "cerrar", path: "/reporte_inicial" },
      { text: 'Ingreso de Facturas y Retenciones', icon: 'document_scanner', accion: "perfil", path: "/ingreso_facturas" },
      // { text: 'Cerrar Sesión', icon: 'logout', accion: "cerrar", path: "/cerrarSesion" }
    ],

    items_reportes_finales: [
      { text: 'Reporte de Transacciones Pasarela de Pago', icon: 'payment', accion: "cerrar", path: "/reporte_transacciones_pasarela" },
      { text: 'Reporte de Usuarios Sin Forma de Pago', icon: 'sd_card_alert', accion: "cerrar", path: "/reporte_usuarios_sin_forma_pago" },
      { text: 'Reporte del Libro de Compras/Ventas', icon: 'event_note', accion: "cerrar", path: "/reporte_compras_ventas" },
      { text: 'Reporte Anual', icon: 'event_note', accion: "cerrar", path: "/reporte_anual" },
      { text: 'Reporte Anual ISR', icon: 'event_note', accion: "cerrar", path: "/reporte_anual/isr" },
      { text: 'Seguimiento de Declaraciones', icon: 'find_in_page', accion: '', path: "/seguimiento_declaraciones" },
      { text: 'Seguimiento de Declaraciones por nit de usuario', icon: 'find_in_page', accion: '', path: "/seguimiento_pornit" },
      { text: 'Estado de declaraciones', icon: 'rule', accion: '', path: "/estado_declaracion_completo" },
      { text: 'Documentos SAT', icon: 'event_note', accion: '', path: "/massive_reporte" },
    ],

    items_administrador: [
      { text: 'Mantenimientos', icon: 'settings', accion: "cerrar", path: "/mantenimientos" },
      { text: 'Administración de usuarios', icon: 'admin_panel_settings', accion: "cerrar", path: "/reporte_usuarios" },
      { text: 'Reporte de Movimientos', icon: 'remove_red_eye', accion: "cerrar", path: "/reporte_movimientos" },
      { text: 'Reporte de Estado de usuarios', icon: 'remove_red_eye', accion: "cerrar", path: "/reporte_usuarios_estado" },
      { text: 'Reporte Maestro x Mes', icon: 'remove_red_eye', accion: "cerrar", path: "/reporte_maestro_mes" },
      { text: 'Declaraciones no confirmadas por Colaborador TIC', icon: 'supervised_user_circle', accion: '', path: "/declaraciones_noconfirmadas_colaborador" },
      { text: 'Declaraciones realizadas por Colaborador TIC', icon: 'supervised_user_circle', accion: '', path: "/declaraciones_colaborador" },
    ],

    items_perfil_gestor: [
      { text: 'Mi Perfil', icon: 'portrait', accion: "perfil", path: "/perfil_usuario/-1" },
      { text: 'Cerrar Sesión', icon: 'logout', accion: "cerrar", path: "/cerrarSesion" }
    ],

    padless: false,
    variant: "default",
    mini: false,
    logo_red,
    logo_ext,
    messages: 0,
    selected: [2],
    benched: 0,
    pantalla: '',
    mostrarLateral: false,
    usuario_rol: 0,
    IDLE_TIMEOUT: 3600,//TIEMPO DE SESSIÓN
    idleSecondsTimer: 0,
    idleSecondsCounter: 0,
    logo_back,

    completo: false,

    nombre_usuario: "",

    roles: [],
    suscripcion_actual: "",

  }),

  async created() {
    sessionStorage.removeItem("CARD_REQUEST");
    this.size;

    document.onclick = () => {
      this.idleSecondsCounter = 0;
    };
    document.onmousemove = () => {
      this.idleSecondsCounter = 0;
    };
    document.onkeypress = () => {
      this.idleSecondsCounter = 0;
    };
    this.idleSecondsTimer = window.setInterval(this.CheckIdleTime, 1000);

    let informacion_incriptada = sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-todo');
    if (informacion_incriptada != null) {
      let key_pass = atob(sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-tic'))
      let bytes = CryptoJS.AES.decrypt(informacion_incriptada, key_pass + "byTeamT0d0T1c");
      //Casteo de información a estring
      let informacion_desincriptada = bytes.toString(CryptoJS.enc.Utf8);
      //Casteo de JSON String a Object json
      let r = JSON.parse(informacion_desincriptada)
      console.log("dataaa", r);
      let data_usuario = r.usuario[0]
      let nombre1 = data_usuario.primer_nombre === null ? "" : data_usuario.primer_nombre;
      let nombre2 = data_usuario.segundo_nombre === null ? "" : data_usuario.segundo_nombre;
      let apellido1 = data_usuario.primer_apellido === null ? "" : data_usuario.primer_apellido;
      let apellido2 = data_usuario.segundo_apellido === null ? "" : data_usuario.segundo_apellido;

      this.nombre_usuario = nombre1 + " " + nombre2 + " " + apellido1 + " " + apellido2;
      // let nombre2
      // this.nombre_usuario.usuario[0].
      this.usuario_rol = r.rol;
      Axios.defaults.headers.common.Accept = 'application/json'
      if (r.token !== null) {
        Axios.defaults.headers.common.Authorization = `Bearer ${r.token}`
      }
    } else {
      this.cerrarSesion();
      this.$toast.warning("Vaya al parecer no has iniciado sesión", { timeout: 2000 })
    }

    // await this.getRoles();
    await this.getSuscripcionActual();

  },
  mounted() {
    console.log("principal");
  },
  computed: {

    filtradoItem() {

      console.log("filtradoItem", this.usuario_rol);
      if (this.usuario_rol.includes(3)) {
        return this.items_perfil;
      } else if (this.usuario_rol.includes(5)) {
        return this.items_perfil_gestor;
      }
      else {
        return this.items_perfil = this.items_perfil.filter(x => x.accion !== "reporte");
      }
    },


    size() {
      const size = { sm: 'small', lg: 'large', xl: 'x-large' }[this.$vuetify.breakpoint.name];
      this.pantalla = size;
      return size ? { [size]: true } : {}
    }
  },
  watch: {

    pantalla() {
      // //console.log("watcher pantalla", this.pantalla);
      if (this.pantalla == undefined) {
        this.mostrarLateral = true;
        // this.items_perfil = this.items_perfil.filter(x => x.icon != 'logout');
      } else {
        this.mostrarLateral = false;
        // this.items_perfil.push();
      }
    }
  },

  methods: {

    hasVerticalScroll(e) {
      this.hasScroll = e.target.defaultView.pageYOffset > 30
    },


    async getSuscripcionActual() {
      try {
        let r = await this.$store.state.services.usuarioService.getSuscripcionActual();
        console.log("suscripciones");
        console.log(r);

        if(r.data.data == null){
          this.suscripcion_actual = "No posee suscripción";
          return;
        }

        if (this.usuario_rol.includes(5) || this.usuario_rol.includes(6)) {
          this.suscripcion_actual = r.data.data[0].nombre;
          return;
        }else if(this.usuario_rol.includes(3)){
          this.suscripcion_actual = r.data.data[0].tipo_suscripcion.nombre

          return;
        }

      } catch {
        this.suscripcion_actual = "No posee suscripción"
      }
    },



    seleccionaInicial() {
      if (this.usuario_rol.includes(1)) {
        this.selectionUserItems("/administrador");
      } else if (this.usuario_rol.includes(2) || this.usuario_rol.includes(4)) {
        this.selectionUserItems("/empleado");
      } else if (this.usuario_rol.includes(3)) {
        this.selectionUserItems("/usuario_final");
      } else if (this.usuario_rol.includes(5) || this.usuario_rol.includes(6)) {
        this.selectionUserItems("/gestor");
      }
    },

    CheckIdleTime() {//valida tiempo de sesión
      let pathname = window.location.pathname;
      // console.log(pathname);
      if (pathname == '/') {
        window.clearInterval(this.idleSecondsTimer);
        const clave_token = "dsgfv/&#$%sdksdn..sd5454sd-tic"
        const clave_data = "dsgfv/&#$%sdksdn..sd5454sd-todo"
        sessionStorage.removeItem(clave_token)
        sessionStorage.removeItem(clave_data)
      } else {
        this.idleSecondsCounter++;
        // console.log(this.idleSecondsCounter);
        if (this.idleSecondsCounter >= this.IDLE_TIMEOUT) {
          window.clearInterval(this.idleSecondsTimer);
          this.$toast.info("Su sesión ha expirado", { position: "top-center" })
          let url = "/"
          const clave_token = "dsgfv/&#$%sdksdn..sd5454sd-tic"
          const clave_data = "dsgfv/&#$%sdksdn..sd5454sd-todo"
          sessionStorage.removeItem(clave_token)
          sessionStorage.removeItem(clave_data)
          this.$router.push({ path: url });
        }
      }
    },

    vista_menu() {//permite la funcionalidad de minimizar menu lateral
      if (this.drawer) {
        if (this.mini) {
          this.mini = false;
        } else {
          this.mini = true;
        }
      } else {
        this.drawer = true;
      }
    },

    selectionUserItems(path) {//seleciona items del menu (Perfil)
      try {
        if (path != "/cerrarSesion") {
          if (this.$route.path === path) {
            //console.log("");//evalua si hacemos click sobre un boton ya seleccionado
            this.$router.go();
          } else {
            this.$router.push({ path: path }).catch(error => {
              if (
                error.name !== 'NavigationDuplicated' &&
                !error.message.includes('Avoided redundant navigation to current location')
              ) {
                this.$router.go();
              } else {
                this.$router.go();
              }
            })
          }
        } else {
          this.cerrarSesion();
        }
      } catch (error) {
        //console.log("")
      }
    },

    cerrarSesion() {//Cerrar sesión
      const clave_token = "dsgfv/&#$%sdksdn..sd5454sd-todo"
      const clave_data = "dsgfv/&#$%sdksdn..sd5454sd-tic"
      sessionStorage.removeItem(clave_token)
      sessionStorage.removeItem(clave_data)
      let url = "/"
      this.$router.push({ path: url });
    },


  },
};